// Memorial entry for Guy Iluz
import guyIluzPortrait from '../../../images/guy-iluz.jpg';

export const guyIluzMemorial = {
  id: 35,
  name: 'Guy Iluz',
  images: {
    portrait: guyIluzPortrait
  },
  info: `
"Nobody is coming out alive. Everybody is dead; nobody is getting out of this alive, so I need to say my last words." - Guy's final phone call

# Guy Iluz

![Guy Iluz](${guyIluzPortrait})
*Guy Iluz, 26, sound engineer with a huge heart*

## Music Was His Life

Guy Iluz received his first guitar at age 7 and spent most of his free time with one in his lap. He studied philosophy and psychology, but music was his calling. He became a professional sound engineer, working with Israeli legends like Shalom Hanoch, Matti Caspi, and the rock band HaYehudim.

He believed in the power of music to connect people. He wrote and composed his own songs. He loved Led Zeppelin.

His friend described him as "a person with a huge heart, who really just wanted the best for people, for them to be happy." His mother Doris, an Israeli-American, raised him as a single mom. "It was me and Guy against the world," she said.

## October 7, 2023

Guy was working as a soundman at the Nova festival when Hamas attacked. He tried to flee in his jeep with friends. Terrorists opened fire - all four passengers were killed. Guy was shot in the arm but escaped and climbed a tree to hide.

At 9:00 a.m., bleeding and wounded, he made his last calls. To Magen David Adom, reporting terrorists. To his father: "Dad, I love you. I wanted to tell you I love you if something happens to me."

His mother was connected by 911. She heard gunshots. Guy said: "Nobody is coming out alive. Everybody is dead... so I need to say my last words."

His father told him to hide under bodies. His mother said "I love you."

Those were her last words to him.

## Eight Days

Guy was found by terrorists and taken to Shifa Hospital in Gaza, bound to a hospital bed for a week with inadequate treatment for his gunshot wound.

Freed hostage Maya Regev was placed in his room about 36 hours before his death. She watched him take his last breaths. He died around October 14-15, 2023 - eight days after capture, from lack of proper medical care.

Guy told Maya his mother was "the strongest woman in the world." Maya promised she would tell his story.

## Coming Home

His remains returned in October 2025 - 738 days later. At the funeral in Ra'anana, his father identified his body: "The first thing I saw was that smile of yours, that optimism... I touched you, tried to smell you, caressed every bone in your body."

Maya Regev spoke: "You waited for me to come so that I could tell your story. You're home now, and the circle is finally closed."

After his death, his mother adopted his habits - a Led Zeppelin ringtone, smoking - "just to feel close to him."

*He always chose joy over sadness. May his memory be a blessing.*

[Read more](https://www.timesofisrael.com/guy-illouz-26-soundman-for-hayehudim-with-a-huge-heart/)
`
};
